var gauge_chart = function () {
    var instance = {};

    //Set scope variable to init dbtable with options, columns etc
    instance.init = function (scope, componentKey, component) {
        //initalise component properties
        $('#' + componentKey).hide();
        scope[componentKey] = {};
        scope[componentKey].instance = {};
        scope[componentKey].data = component.init_config;
    };

    /**
     * Prepare style for this gauge chart component
     * @param component_root
     * @param gauge_label_distance
     */
    instance.prepareStyle = function (component_root, gauge_label_distance) {
        $('<style>').text(
            '.gauge_container {\n' +
            '  margin-bottom: 10px;\n' +
            '  text-align: center!important;\n' +
            '}\n' +
            '.gauge_container .gauge-chart {\n' +
            '  z-index: 1;\n' +
            '  position: relative;\n' +
            '}\n' +
            '.gauge_container .gauge-chart .highcharts-container {\n' +
            '  margin: 0 auto;\n' +
            '}\n' +
            '.gauge_container .metric-container {\n' +
            '  z-index: 10;\n' +
            '  position: relative;\n' +
            '}\n' +
            '.gauge_container div.label {\n' +
            '  position: relative;\n' +
            '}\n' +
            '.gauge_container .highcharts-container {\n' +
            '  margin-left: auto!important;\n' +
            '  margin-right: auto!important;\n' +
            '  text-align: center!important;\n' +
            '}\n' +
            '.gauge_container .gauge {\n' +
            '  font-size: 22px;\n' +
            '  position: relative;\n' +
            '  top: ' + gauge_label_distance + ';\n' +
            '  text-align: center;\n' +
            '}'
        ).appendTo(component_root);
    };

    /**
     * @param metric_data
     * @param property_key
     * @returns {*}
     */
    instance.getReturnProperty = function (metric_data, property_key) {
        var property_value = null;
        try {
            property_value = metric_data[property_key];
        } catch (e) {
            // by pass
        }
        return property_value;
    };

    /**
     * @param scope
     * @param componentKey
     * @param resultComponentVal
     */
    instance.update = function (scope, componentKey, resultComponentVal) {
        var config_data = scope[componentKey].data;

        //extend the component config with the result data
        $.extend(true, config_data, resultComponentVal.config);
        resultComponentVal.config = config_data;

        //reset component properties
        scope[componentKey] = {};
        scope[componentKey].instance = {};

        var metric_data = resultComponentVal.data;
        if (instance.getReturnProperty(metric_data, 'is_no_data')) {
            return;
        }
        var my_score = instance.getReturnProperty(metric_data, 'my_score');
        var previous_score = instance.getReturnProperty(metric_data, 'previous_score');
        var target_score = instance.getReturnProperty(metric_data, 'target_score');
        var gauge_border_color = instance.getReturnProperty(metric_data, 'gauge_border_color');
        var arrow = instance.getReturnProperty(metric_data, 'arrow');
        var arrow_color = instance.getReturnProperty(metric_data, 'arrow_color');
        var gauge_max_score = instance.getReturnProperty(metric_data, 'gauge_max_score');
        var gauge_label_distance = instance.getReturnProperty(metric_data, 'gauge_label_distance');
        var gauge_min_value = instance.getReturnProperty(metric_data, 'gauge_min_value');
        var gauge_label_step = instance.getReturnProperty(metric_data, 'gauge_label_step');
        var gauge_tick_interval = instance.getReturnProperty(metric_data, 'gauge_tick_interval');
        var gauge_diameter = instance.getReturnProperty(metric_data, 'gauge_diameter');
        var gauge_font_size = instance.getReturnProperty(metric_data, 'gauge_font_size');
        var gauge_score_distance_to_top = instance.getReturnProperty(metric_data, 'gauge_score_distance_to_top');

        resultComponentVal.config['options'].yAxis.plotBands[0].to = parseFloat(my_score);
        resultComponentVal.config['options'].yAxis.plotBands[0].color = gauge_border_color;
        resultComponentVal.config['options'].yAxis.plotBands[1].from = parseFloat(my_score);
        resultComponentVal.config['options'].yAxis.plotBands[1].to = gauge_max_score;
        resultComponentVal.config['options'].yAxis.min = gauge_min_value;
        resultComponentVal.config['options'].yAxis.max = gauge_max_score;
        resultComponentVal.config['options'].yAxis.labels.step = gauge_label_step;
        resultComponentVal.config['options'].yAxis.labels.style.fontSize = gauge_font_size;
        resultComponentVal.config['options'].yAxis.labels.distance = gauge_label_distance;
        resultComponentVal.config['options'].yAxis.tickInterval = gauge_tick_interval;
        resultComponentVal.config['options'].chart.height = gauge_diameter;
        resultComponentVal.config['options'].chart.width = gauge_diameter;
        // For exporting
        resultComponentVal.config['options']['my_score'] = my_score;
        resultComponentVal.config['options']['previous_score'] = previous_score;
        resultComponentVal.config['options']['target_score'] = target_score;

        //update component
        scope[componentKey].data = resultComponentVal.config;

        setTimeout(function () {
            var gauge_inner = my_score ? my_score : '-'; // back-end also has similar logic to use when my_score is null
            if (arrow && arrow !== 'none' && gauge_inner !== '-') {
                gauge_inner = gauge_inner + ' <i class="fa fa-caret-' + arrow + '" style="color: ' + arrow_color + '"></i>';
            }
            var tooltip_title = target_score != '' ? 'Target - '+target_score : '';
            $('#' + componentKey).wrap('<div class="gauge_container tooltip-element-wrap" data-toggle="tooltip" title="'+tooltip_title+'">' +
                '<div class="gauge-chart"></div>' +
                '<div class="gauge metric-container"> ' + gauge_inner + '</div>' +
                '</div>');
            instance.prepareStyle($(".gauge_container"), gauge_score_distance_to_top);
            $('#' + componentKey).show();
        }, 500);
    };

    return instance;
};
